/* eslint-disable */
// MARK: Done

import { HiX } from "react-icons/hi";
import Links from "./components/Links";

import {
  renderThumb,
  renderTrack,
  renderView,
  renderViewMini,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import routes from "routes";
import { useTranslation } from "react-i18next";
import { shallowEqual, useSelector } from "react-redux";
import SidenavCard from "widgets/cards/sidenav";
import { account } from "store/account/accountSelectors";
import useWhiteLabel from "whitelabel/useWhiteLabel";
import { SIDEBAR_WIDTH } from "hooks/viewport-dimensions";

function SidebarHorizon(props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
  variant?: string;
  [x: string]: any;
}) {
  const { open, onClose, variant, mini, hovered, setHovered } = props;
  const { t } = useTranslation();
  const accountContext = useSelector(account, shallowEqual);
  const { images } = useWhiteLabel();

  return (
    <div
      className={`duration-175 linear fixed !z-50 min-h-full transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
        variant === "auth" ? "xl:hidden" : "xl:block"
      } ${open ? "" : "-translate-x-[110%] xl:translate-x-[unset]"}`}
      style={{
        width: `${SIDEBAR_WIDTH}px`,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <SidenavCard
        extra={`round-none w-full h-[100vh] sm:mr-4 sm:my-4 md:my-0 bg-background-50`}
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={
            mini === false
              ? renderView
              : mini === true && hovered === true
              ? renderView
              : renderViewMini
          }
        >
          <div className="flex h-full flex-col justify-between">
            <div>
              <span
                className="absolute right-4 top-4 block cursor-pointer text-white xl:hidden"
                onClick={onClose}
              >
                <HiX />
              </span>
              <div className={`mt-10 flex items-center justify-center px-6`}>
                <div
                  className={`heading-lg uppercase text-white ${
                    mini === false
                      ? "block"
                      : mini === true && hovered === true
                      ? "block"
                      : "hidden"
                  }`}
                >
                  <img src={images.SIDEBAR_LOGO} alt="Overlay" />
                </div>
              </div>
              <div className="mb-7 mt-10 h-px bg-background-900" />
              <div className="heading-md mb-4 ml-7 text-white">
                {accountContext.name}
              </div>
              {/* Nav item */}
              <ul>
                <Links
                  mini={mini}
                  hovered={hovered}
                  routes={routes}
                  onMenuItemClick={() => onClose}
                />
              </ul>
            </div>
          </div>
        </Scrollbars>
      </SidenavCard>
    </div>
  );
}

export default SidebarHorizon;
